import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, ArrowLeft } from 'lucide-react';
import EmptyState from '../components/ui/EmptyState';

const NotFound = () => (
    <div className="max-w-2xl mx-auto px-6 py-24">
        <EmptyState
            icon={Compass}
            title="404 — Không có gì ở đây"
            message="Đường dẫn này không tồn tại, hoặc đã chuyển đi nơi khác."
            action={
                <Link
                    to="/"
                    className="btn-accent"
                >
                    <ArrowLeft className="w-4 h-4" />
                    Về trang chủ
                </Link>
            }
        />
    </div>
);

export default NotFound;
